import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import { RequestErrorCallout } from 'components/Errors/RequestErrorCallout'
import { useAddBusinessCustomer } from 'hooks/queries/Customers/useAddBusinessCustomer'
import { useMappedErrorMessage } from 'hooks/useMappedErrorMessage'
import { AddCustomerActions } from 'pages/EmbeddedCustomers/AddCustomer/AddCustomerActions'
import { buildAddBusinessCustomerPayload } from '../helpers/buildAddBusinessCustomerPayload'
import { getConfirmItems } from '../helpers/getConfirmItems'
import type { ConfirmBusinessCustomerV2Data } from '../helpers/types'

export interface AddCustomerConfirmDetailsProps {
  confirmData: ConfirmBusinessCustomerV2Data
  onSuccess: () => void
  onCancel: () => void
}

export const AddCustomerConfirmDetails = ({
  confirmData,
  onSuccess,
  onCancel,
}: AddCustomerConfirmDetailsProps) => {
  const { t } = useTranslation()
  const { requestError, handleRequestError, resetRequestError } = useMappedErrorMessage()
  const { mutate: submitApplication, isPending: isSubmitting } = useAddBusinessCustomer()

  const { data, displayData } = confirmData

  const confirmItems = getConfirmItems(t, data, displayData)

  const onConfirm = () => {
    resetRequestError()
    submitApplication(buildAddBusinessCustomerPayload(data), {
      onSuccess,
      onError: error => {
        handleRequestError(error, '/onboarding/v1/applications', 'postAddBusinessCustomer', true)
      },
    })
  }

  return (
    <>
      {requestError?.show && (
        <Box paddingT={24}>
          <RequestErrorCallout requestError={requestError} />
        </Box>
      )}
      {confirmItems.map(({ id, title, body }) => (
        <DataListItem key={id} id={id} title={title} body={body} />
      ))}
      <AddCustomerActions
        onCancel={onCancel}
        onConfirmDetails={onConfirm}
        isLoadingConfirm={isSubmitting}
      />
    </>
  )
}
